import { GeoLocation } from 'components/GeoLocationComponent/GeoLocationComponent';
import { toast } from 'react-toastify';

export const MAX_GEO_LOCATION_BYTES = 921600; // 900KB - leaves ~100KB buffer for rest of request

/** Validates that geolocation data doesn't exceed the API limit */
export const validateGeoLocationSize = (
  geoLocation: GeoLocation | null | undefined
) => {
  if (!geoLocation) {
    return { isValid: true, locationString: null };
  }

  const locationString = JSON.stringify(geoLocation);
  const locationSize = new Blob([locationString]).size;

  const isValid = locationSize <= MAX_GEO_LOCATION_BYTES;

  if (!isValid) {
    toast.warn(
      `Geolocation data (${locationSize} bytes) exceeds limit. Excluding from request.`
    );
  }

  return {
    isValid,
    locationString,
  };
};
